<template>
    <div class="events">
        <div class="events-now-showing" v-if="nowShowingEvent">
            <h1>Now Showing</h1>
            <Event
                :key="nowShowingEvent.nid"
                :event="nowShowingEvent"
                :teaser="false"
            />
        </div>

        <Newsletter heading="Subscribe for upcoming shows" />

        <div class="events-upcoming" v-if="upcomingEvents.length">
            <h1>Upcoming Events</h1>
            <div class="events-results">
                <Event
                    @click="selectedEvent = event"
                    v-for="event in upcomingEvents"
                    :key="event.nid"
                    :event="event"
                />
            </div>
        </div>
        <div class="events-past" v-if="pastEvents.length">
            <h1>Past Events</h1>
            <div class="events-results">
                <Event
                    @click="selectedEvent = event"
                    v-for="event in pastEvents"
                    :key="event.nid"
                    :event="event"
                />
            </div>
        </div>
        <transition name="modal">
            <modal v-if="selectedEvent" @close="selectedEvent = null">
                <template v-slot:body>
                    <Event
                        :key="selectedEvent.nid"
                        :event="selectedEvent"
                        :teaser="false"
                    />
                    <a
                        v-if="previousEvent"
                        @click="selectedEvent = previousEvent"
                        class="prev"
                        >Prev</a
                    >
                    <a
                        v-if="nextEvent"
                        @click="selectedEvent = nextEvent"
                        class="next"
                        >Next</a
                    >
                    <div style="display: none" class="preloader">
                        <img
                            :src="previousEvent.fullImage"
                            v-if="previousEvent"
                        />
                        <img :src="nextEvent.fullImage" v-if="nextEvent" />
                    </div>
                </template>
            </modal>
        </transition>
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";
import Newsletter from '@/components/Newsletter.vue';

export default {
    name: "Events",
    mixins: [ArtworkHelper],
    components: { Newsletter },
    data() {
        return {
            selectedEvent: null,
        };
    },
    computed: {
        documentTitle() {
            return "Now Showing | " + this.documentTitleBase;
        },
        selectedEventIndex() {
            const vm = this;
            return vm.allEvents.indexOf(vm.selectedEvent);
        },
        previousEvent() {
            const vm = this;
            if (vm.selectedEventIndex > 0) {
                return vm.allEvents[vm.selectedEventIndex - 1];
            }
            return null;
        },
        nextEvent() {
            const vm = this;
            return vm.allEvents[vm.selectedEventIndex + 1];
        },
    },
};
</script>

<style lang="scss">
</style>
